import { createSlice } from "@reduxjs/toolkit"

export const customerAddressListSlice = createSlice({
	name: "customerAddress_list",
	initialState: {
		customerAddress: "",
		errors: [],
	},

	reducers: {
        getCustomerAddress: (state, action) => {
            // console.log(action.payload);
			state.customerAddress = action.payload
		},
		getCustomerAddressList: (state, action) => {
			state.customerAddress = action.payload
		},
		getErrors: (state, action) => {
			state.errors = action.payload
		},
	},
})
export const {getCustomerAddress, getCustomerAddressList, getErrors} = customerAddressListSlice.actions

export default customerAddressListSlice.reducer
